import { Monitor } from "lucide-react";
import { Link } from "react-router-dom";

export function ImportMobileBlocker() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center md:hidden">
      <div className="mb-6 flex size-14 items-center justify-center rounded-2xl bg-app-surface-2 text-app-ink-2">
        <Monitor size={28} strokeWidth={1.5} />
      </div>
      <h2 className="mb-2 font-semibold text-2xl text-app-ink-1 tracking-tight">
        Abrilo en computadora
      </h2>
      <p className="mb-8 max-w-md text-app-ink-2 text-sm leading-relaxed">
        El import de un CSV requiere ver muchos datos a la vez. Abrí esta página en una computadora
        para subir tu hato.
      </p>
      <Link
        to="/app/hato"
        className="inline-flex items-center justify-center rounded-2xl border border-app-border bg-app-surface px-4 py-3 font-medium text-[14px] text-app-ink-1 transition-colors hover:bg-app-surface-2"
      >
        Volver al hato
      </Link>
    </div>
  );
}
